import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import HomepageSidebar from "./components/Homepage/HomePageSidebar";
import HomePageTopBar from "./components/Homepage/HomePageTopBar";
import HomePageContents from "./components/Homepage/HomePageContents";
import DocumentViewer from "./components/Documents/DocumentViewer";
import CalendarPage from "./components/Calendar/CalendarPage";
import LoginForm from "./components/LoginForm/LoginForm";
import RegisterForm from "./components/RegisterForm/RegisterForm";
import KanbanBoard from "./components/Homepage/KanbanBoard";
import UserSettings from "./components/Settings/UserSettings";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ForgotPassword/ResetPassword";
import ConfirmUsername from "./components/Settings/ConfirmUsername";
import ConfirmPassword from "./components/Settings/ConfirmPassword";
import moment from "moment";
import "./style/App.css";

function App() {
  const today = moment();
  const [year, setYear] = useState(today.year());
  const [month, setMonth] = useState(today.month() + 1);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, userId } = useAuth();

  // ✅ NEW: Sidebar collapsed state
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  // Allow access to login and register pages without being redirected
  // useEffect(() => {
  //   if (!isAuthenticated && !["/login", "/register"].includes(location.pathname)) {
  //     window.location.replace(`http://localhost:3000/#/login`);
  //   }
  // }, [isAuthenticated, location]);

  // Improved version of useEffect below
  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuthenticated") === "true";
    const storedUserId = localStorage.getItem("userId");
    
    if (!storedAuth || !storedUserId) {
      if (!["/login", "/register", "/forgot-password", "/reset-password", "/confirm-username", "/confirm-password"].includes(location.pathname)) {
        navigate("/login");
      }
    }
  }, [isAuthenticated, location, navigate]);
  
  return (
    <div className={location.pathname.includes("login") || location.pathname.includes("register") ? "App_Login" : "App"}>
      {!isAuthenticated ? (
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element= {<ResetPassword />} />
          <Route path="/confirm-username" element = {<ConfirmUsername />} />
          <Route path="/confirm-password" element = {<ConfirmPassword />} />
          <Route path="*" element={<Navigate replace to="/login" />} />
        </Routes>
      ) : (
        <div className="MainContainer">
          <HomePageTopBar />
          <div className="MainContent">
            {/* ✅ Pass collapsed state to Sidebar */}
            <HomepageSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            
            {/* ✅ Dynamically shift content based on collapse state */}
            <div className={collapsed ? "ContentArea collapsed" : "ContentArea"}>
              <Routes>
                <Route path="/" element={<Navigate replace to="/home" />} />
                <Route path="/home" element={
                  <div className="homePageContainer">
                    <HomePageContents />
                    <KanbanBoard />
                  </div>
                } />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/documents" element={<DocumentViewer userId={userId} collapsed={collapsed} />} />
                <Route path="/settings" element={<UserSettings />} />
              </Routes>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;